/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_No_RowsInputs */

const en_issue_no_rows = /** @type {(inputs: Issue_No_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has no rows`)
};

/**
* | output |
* | --- |
* | "has no rows" |
*
* @param {Issue_No_RowsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_no_rows = /** @type {((inputs?: Issue_No_RowsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_No_RowsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_no_rows(inputs)
});